module.exports = __webpack_public_path__ + "static/media/t7.f8f63f91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/t7.jpg
// module id = 408
// module chunks = 0